import chinaRegObj from './chinaRegObj'

export default {
  chinaRegObj
}
